<template>
    <tr>
        <td>
            <input v-model="value.group" class="form-control" />
        </td>
        <td>
            <input v-model="value.amount" class="form-control" />
        </td>
        <td>
            <input v-model="value.price" class="form-control" />
        </td>
        <td>
            <input
                v-model="value.commission"
                @input="updateItem"
                class="form-control"
            />
        </td>
        <td>
            <select
                v-model="value.commission_type"
                @input="updateItem"
                class="form-control"
            >
                <option value="fixed">Fixed</option>
                <option value="percentage">Percentage</option>
            </select>
        </td>
        <td>
            <input :value="total" disabled :key="total" class="form-control" />
        </td>
        <td>
            <input
                :value="commissionTotal"
                disabled
                :key="commissionTotal"
                class="form-control"
            />
        </td>
        <td style="width: 40px;">
            <div class="d-flex">
                <button
                    type="button"
                    @click="removeGroup"
                    class="btn btn-danger btn-lg px-2 mr-2"
                    v-if="isRemovable"
                ><i class="lar la-trash-alt"></i></button>
                <button
                    type="button"
                    @click="addGroup"
                    class="btn btn-primary btn-lg px-2"
                ><i class="las la-plus"></i></button>
            </div>
        </td>
    </tr>
</template>

<script setup>
import { computed, reactive, defineEmits, watch } from "vue";
import _ from "lodash";

const emit = defineEmits(["update:group", "remove:group", "add:group"]);
const { group } = defineProps(["group", "isRemovable"]);
const value = reactive({ ...group });

const addGroup = () => {
    emit('add:group');
}

const removeGroup = () => {
    if (confirm("Groep verwijderen?")) {
        emit('remove:group');
    }
}

watch(
    value,
    () => {
        emit("update:group", value);
    },
    { deep: true }
);

const commissionTotal = computed(() => {
    let commissionTotal;

    switch (value.commission_type) {
        case "percentage":
            commissionTotal = (total.value / 100) * value.commission;
            break;
        default:
            commissionTotal = value.amount * value.commission;
            break;
    }

    return Number(commissionTotal).toFixed(2);
});

const total = computed(() => value.amount * value.price);
</script>
